export function FormRow(props: { children: React.ReactNode }) {
  return (
    <div className="flex w-full flex-col gap-4 md:flex-row">
      {props.children}
    </div>
  );
}
